<script lang="ts">
export default {
  inheritAttrs: false
};
</script>

<script setup lang="ts">
import { computed } from "vue";

import type { DictsysCustomValue } from "@/types";

const props = defineProps<{ values: DictsysCustomValue[] }>();

const beforeContent = computed<string | null>(() => props.values.find((v) => v.position === "before")?.text ?? null);

const afterContent = computed<string | null>(() => props.values.find((v) => v.position === "after")?.text ?? null);
</script>

<template>
  <span v-if="beforeContent" v-bind="$attrs">{{ beforeContent }}</span>
  <slot />
  <span v-if="afterContent" v-bind="$attrs">{{ afterContent }}</span>
</template>
